import { getMonthDaysChunkedByWeek, MonthChunkedByWeek } from '../../Datepicker.utils';
import { StyledTable } from '../../Datepicker.styles';
import { DatepickerRange } from './DatepickerRange';
import { DatepickerType, weekDays } from '../../Datepicker.consts';
import { DatepickerSingle } from './DatepickerSingle';
import { DatepickerGridProps } from './DatepickerGrid.consts';
import { useMemo } from 'react';

export const DatepickerGrid: React.FC<DatepickerGridProps> = ({
  month,
  year,
  type,
}: DatepickerGridProps) => {
  const chunkedMonthDays: MonthChunkedByWeek[][] = useMemo(
    () => getMonthDaysChunkedByWeek(month, year),
    [month, year]
  );

  const days = useMemo(
    () =>
      chunkedMonthDays.map((days, i) => (
        <tr key={`week-${i}`}>
          {days.map((day) =>
            type === DatepickerType.RANGE ? (
              <DatepickerRange
                key={`week-${i}-day-${day.id}`}
                day={day.id}
                className={day.className}
              />
            ) : (
              <DatepickerSingle
                key={`week-${i}-day-${day.id}`}
                day={day.id}
                className={day.className}
              />
            )
          )}
        </tr>
      )),
    [chunkedMonthDays, type]
  );

  return (
    <StyledTable>
      <tr>
        {weekDays.map((day, i) => (
          <th key={`day-${i}`}>{day}</th>
        ))}
      </tr>
      {days}
    </StyledTable>
  );
};
